import React from 'react';
import { EndpointRole } from '@fluidprompter/core';

import AppNoticeBar from '../AppNoticeBar';
import Navbar from '../Navbar';
import PrompterHudLeft from '../PrompterHudLeft';
import PrompterHudRight from '../PrompterHudRight';
import ControlBar from '../ControlBar';

import useConfigurationStore from '../../state/ConfigurationStore';
import usePrompterSession from '../../state/PrompterSessionState';
import useViewportDimensions from '../PrompterViewport/useViewportDimensions';

import './PrompterViewportUIContainer.scss';

function PrompterViewportUIContainer() {

  const showStats = useConfigurationStore(state => state.showStats);

  const endpointRole = usePrompterSession(state => state.endpointRole);

  //
  // This is the new way to calculate viewport dimensions
  //
  const {
    topOffset,
    leftOffset,
    rightOffset,
    bottomOffset,
    width,
    height,
  } = useViewportDimensions();

  return (<div
    className='PrompterViewportUIContainer'
    style={{
      top: `${topOffset}vh`,
      left: `${leftOffset}vw`,
      right: `${rightOffset}vw`,
      bottom: `${bottomOffset}vh`,
    }}
  >
    {/* AppNoticeBar's outer element will have classname `NoticeBarContainer` */}
    <AppNoticeBar />
    <div className='NavbarContainer'>
      <Navbar endpointRole={endpointRole} />
    </div>
    {(endpointRole === EndpointRole.Prompter) && <div className='LeftHUDContainer'>
      <PrompterHudLeft />
    </div>}
    {(showStats && endpointRole === EndpointRole.Prompter) && <div className='RightHUDContainer'>
      <PrompterHudRight />
    </div>}
    <div className='ControlBarContainer'>
      <ControlBar />
    </div>
  </div>);
}

export default PrompterViewportUIContainer;